import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "hyphenate"];
import styled from 'foundations-theming/utils';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { filterProps } from '../../../utils/filterProps';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledBreakString = styled.span.withConfig({
  displayName: "BreakString__StyledBreakString",
  componentId: "sc-106dya3-0"
})(({
  $hyphenate,
  $cssStyles
}) => Object.assign({
  overflowWrap: 'break-word',
  wordWrap: 'break-word',
  wordBreak: 'break-word',
  hyphens: $hyphenate ? 'auto' : 'none',
  webkitHyphens: $hyphenate ? 'auto' : 'none'
}, $cssStyles));
export const BreakString = _ref => {
  let {
      children,
      hyphenate
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    tokenProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(StyledBreakString, Object.assign({
    $hyphenate: hyphenate,
    $cssStyles: cssStyles
  }, domProps, {
    children: children
  }));
};